import { NgModule } from "@angular/core";
import * as quill from "quill";
import { appDeclerations } from "./app.declerations";
import { imports } from "./app.imports";
import { appProviders } from "./app.providers";
import { AppComponent } from "./components/app/app.component";

window["Quill"] = quill;

@NgModule({
    bootstrap: [AppComponent],
    declarations: appDeclerations,
    imports: imports,
    providers: appProviders,
})
export class AppModuleShared {}
